import React from 'react'
import Fill from '../pages/Fill'


function Main() {
  return (
    <div className='main'>
      <Fill />
    </div>
  )
}

export default Main;

